<div class="d-flex flex-column flex-md-row align-items-md-center p-4 p-md-10">
  <img src="assets/images/done.webp" alt="done" width="280" height="280" class="mx-auto" />

  <div class="mt-6 mt-md-0 ml-md-10 w-400">
    <h1 class="semi-bold" data-id="title">Your request has been sent</h1>

    <p class="mt-2">
      We’ll review your preferences and follow up with updated options as soon as possible
    </p>
  </div>
</div>
